export const scalar = {
    clamp: (val: number, min: number, max: number) => {
        return Math.max(min, Math.min(val, max));
    },
    lerp: (start: number, end: number, t: number) => {
        return start + ((end - start) * t);
    }
}